import React from 'react';
import type { ComponentProps } from 'react';

import { SubtitleST4 } from 'common/components/Typography';
import type { Color } from 'common/theme/colors/types';
import type { BannerProps } from '../../../types';

type CampaignDurationProps = {
  campaignDuration?: BannerProps['campaignDuration'];
  textColor?: Color;
};

const innerCampaignDurationStyles: ComponentProps<typeof SubtitleST4> = {
  m: 'sp_0',
  color: 'sys.neutral.text.strong',
};

const CampaignDuration = ({ campaignDuration, textColor }: CampaignDurationProps) => {
  if (!campaignDuration) return null;

  return (
    <SubtitleST4 {...innerCampaignDurationStyles} color={textColor}>
      {campaignDuration}
    </SubtitleST4>
  );
};

export default CampaignDuration;
